<div *ngIf="taskState != 'Done'" class="card mb-3">
    <div class="card-body">
        <h2 class="f-20" style="font-weight: 500;">{{taskTitle}}</h2>
        <quill-view-html class="quill-no-pad f-15" [content]="taskDescription"></quill-view-html>
        <a download (click)="downloadAction()" href="{{linkurl}}" target="_blank"><button class="btn mt-2 btn-noround">
                <p class="mb-0 btn-text f-15" style="font-weight: 600;">{{linktext}}</p>
            </button></a>
    </div>
</div>

<div *ngIf="taskState == 'Done'" class="card mb-3">
    <div class="card-body">
        <div class="d-inline-flex">
            <span class="material-icons lh-25 align-middle" style="color:green;">
                task_alt
            </span>
            <h2 class="f-20 lh-25 align-middle pl-2 pr-2" style="font-weight: 500;">{{taskTitle}}</h2>
            <span class="badge badge-success" style="height:19px; margin-top:2px;">{{ 'cpllist.completed' | trans
                }}</span>
        </div>
        <quill-view-html class="quill-no-pad f-15" [content]="taskDescription"></quill-view-html>
        <a download href="{{linkurl}}"><button class="btn mt-2 btn-noround">
                <p class="mb-0 btn-text f-15" style="font-weight: 600;">{{linktext}} <span
                        class="material-icons lh-25 align-middle">
                        done
                    </span></p>
            </button></a>

    </div>
</div>